import React from "react";
import { useHistory } from "react-router-dom";

export const LogoArea = () => {
  let history = useHistory();
  const handleLogoClick = () => {
    let url = window.location.href.split("/");
    let baseUrl = url[0] + "//" + url[2];

    if (history.location.pathname !== "/dashboard") {
      localStorage.setItem("DivName", JSON.stringify("Dashboard"));
      window.open(baseUrl, "_blank");
    }
  };

  return (
    <div className="logoArea" onClick={handleLogoClick}>
      <div className="logoTransition logoSize">
        <img style={{height:"35px"}} src="images/Logo.png" alt="" />
      </div>
      {/* <div className="accountButton">
        <div className="accountButtonText">
          <div className="accountButtonText_style">Free</div>
        </div>
      </div> */}
    </div>
  );
};

export default LogoArea;
